import CrudApi from './crud';

export const crud = new CrudApi('/admin/essentials', { only: ['index', 'store', 'update', 'show'] });
